// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ql-editor a{color:#337ab7;text-decoration:underline}.ql-editor h2{font-size:1.5em}.ql-editor h3{font-size:1.17em}.ql-editor.ql-blank::before{font-size:17px}", ""]);
// Exports
module.exports = exports;
